import getSuggestions from '../actions/getSuggestions';
import onSearchInputFocused from '../actions/onSearchInputFocused';
import onSearchTextChanged from '../actions/onSearchTextChanged';
import startSearchSession from '../actions/startSearchSession';
import isSearchSessionActive from '../selectors/isSearchSessionActive';
import getScenarioStore from '../store/getScenarioStore';
import { orchestrator } from 'satcheljs';

orchestrator(onSearchInputFocused, actionMessage => {
    const { scenarioId } = actionMessage;

    // Start the search session if one isn't active.
    if (!isSearchSessionActive(scenarioId)) {
        startSearchSession('SearchBox', false /* shouldStartSearch */, scenarioId);
        return;
    }

    const { searchText, searchTextForSuggestion } = getScenarioStore(scenarioId);

    /**
     * If searchText (text in the search box) already matches searchTextForSuggestion,
     * then there's no need to update the store or refresh suggestions.
     */
    if (searchText && searchText === searchTextForSuggestion) {
        return;
    }

    // Ensure searchTextForSuggestion matches the text in the search box (searchText).
    onSearchTextChanged(searchText, scenarioId, true /* showSuggestionsUi */);

    // Get suggestions to ensure results match current search box state.
    getSuggestions(scenarioId);
});
